import { Router, Route, Switch } from 'wouter'
import { Home } from './pages/Home'
import { Lorebook } from './pages/Lorebook'
import { LorebookDetail } from './pages/LorebookDetail'
import { Export } from './pages/Export'
import { Characters } from './pages/Characters'
import { CharacterNew } from './pages/CharacterNew'
import { CharacterDetail } from './pages/CharacterDetail'
import { CharacterEdit } from './pages/CharacterEdit'

export function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/lorebook" component={Lorebook} />
        <Route path="/lorebook/:id">{(params) => <LorebookDetail id={params.id} />}</Route>
        <Route path="/export" component={Export} />
        <Route path="/characters" component={Characters} />
        <Route path="/characters/new" component={CharacterNew} />
        <Route path="/characters/:id/edit">{(params) => <CharacterEdit id={params.id} />}</Route>
        <Route path="/characters/:id">{(params) => <CharacterDetail id={params.id} />}</Route>
        <Route>
          <div className="lorebook-root flex min-h-screen flex-col items-center justify-center gap-6 px-6">
            <img
              src="/logo.png"
              alt="System 404: Signal Lost"
              width={1699}
              height={624}
              className="w-full max-w-xl"
            />
            <a href="/" className="text-signal hover:underline">
              Return to the map
            </a>
          </div>
        </Route>
      </Switch>
    </Router>
  )
}
